import { getClassNames } from '@websolutespa/bom-core';
import { LlmBlock, LlmChunkUnknownItem } from '@websolutespa/bom-mixer-llm';
import style from './not-found.module.scss';

export const NotFound: React.FC<LlmBlock<LlmChunkUnknownItem>> = (props) => {
  const { item } = props;
  const classNames = getClassNames(style.notFound, { [`.notFound--${item.type}`]: !!item.type });
  return (
    <pre className={classNames}>{JSON.stringify(item, null, 2)}</pre>
  );
};
